import React, { useEffect, useRef, useState } from "react";
import { titles } from "../assets/data/titles";

import VirtualScroll from "virtual-scroll";

import { lerp, convertRem } from "../utils/math";

import { motion } from "framer-motion";

import { useHistory } from "react-router-dom";

import { isMobile } from "react-device-detect";

const IndexNav = ({ onMouseEnter, onMouseLeave }) => {
  const scrollContainer = useRef();
  const [hovered, setHovered] = useState(null);
  const direction = useRef(1);
  const requestRef = useRef(); //requestAnimation way
  var scroll = useRef(null);
  const titlesRef = useRef([]);
  const history = useHistory();

  const state = useRef({
    bounds: {},
    current: 200,
    last: 0,
    dragStart: 0,
    dragEnd: 0,
    dragging: false,
  });
  const options = useRef({
    ease: 0.1,
    dragSpeed: 1.5,
  });

  //*********** */
  const [mouse, setMouse] = useState({ x: 50, y: 50 });

  useEffect(() => {
    function handlePosition(e) {
      let x = e.clientX;
      let y = e.clientY;
      setMouse({ x, y });
    }

    window.addEventListener("mousemove", handlePosition);
    return () => window.removeEventListener("mousemove", handlePosition);
  }, []);

  useEffect(() => {
    scroll.current = new VirtualScroll({
      useTouch: true,
      mouseMultiplier: 0.4,
      useKeyboard: true,
    });
    addListeners();
    handleResize();
    scroll.current.on(calc);
    // gsap.ticker.add(smooth); //way gsap

    requestRef.current = requestAnimationFrame(smooth); // requestAnimation way

    return () => {
      removeListeners();
      cancelAnimationFrame(requestRef.current); //requestAnimation way
      scroll.current.destroy();
    };
  }, []);

  const addListeners = () => {
    window.addEventListener("resize", handleResize, { passive: true });
    //check if is not mobile
    window.addEventListener("mouseup", handleMouseup);
    window.addEventListener("mousedown", handleMousedown);
    window.addEventListener("mouseleave", handleMouseleave);
    window.addEventListener("mousemove", handleMousemove);
  };

  const removeListeners = () => {
    window.removeEventListener("resize", handleResize, { passive: true });
    //check if is not mobile
    window.removeEventListener("mouseup", handleMouseup);
    window.removeEventListener("mousedown", handleMousedown);
    window.removeEventListener("mouseleave", handleMouseleave);
    window.removeEventListener("mousemove", handleMousemove);
  };

  const handleMouseup = () => {
    state.current.dragging = false;
    state.current.dragEnd = state.current.current;

    document.body.classList.remove("is-dragging");
  };

  const handleMousedown = (e) => {
    state.current.dragging = true;

    state.current.dragEnd = state.current.current;
    state.current.dragStart = e.clientX;

    document.body.classList.add("is-dragging");
  };

  const handleMousemove = (e) => {
    if (!state.current.dragging) return;

    state.current.current =
      state.current.dragEnd +
      (e.clientX - state.current.dragStart) * options.current.dragSpeed;
  };

  const handleMouseleave = () => {
    state.current.dragging = false;
    state.current.dragEnd = state.current.current;

    document.body.classList.remove("is-dragging");
  };

  const calc = (e) => {
    //mobile ***
    if (isMobile) {
      state.current.current += e.deltaX;
    } else {
      state.current.current += e.deltaY;
    }
    //
  };

  const changeXPositions = () => {
    titlesRef.current.map((el) => {
      if (el) {
        const measures = el.getBoundingClientRect();
        const displace = 255.25 + 5.5 + 5;

        if (direction.current === 1) {
          if (measures.x + measures.width < 0) {
            el.style.left = `${parseInt(el.style.left, 10) + displace}rem`;
          }
        } else {
          if (measures.x > window.innerWidth)
            el.style.left = `${parseInt(el.style.left, 10) - displace}rem`;
        }
      }
    });
  };

  const smooth = () => {
    changeXPositions();
    state.current.current -= 1;
    state.current.last = lerp(
      state.current.last,
      state.current.current,
      options.current.ease
    );
    if (state.current.current < state.current.last && direction.current !== 1) {
      direction.current = 1;
    }
    if (
      state.current.current > state.current.last &&
      direction.current !== -1
    ) {
      direction.current = -1;
    }
    if (scrollContainer.current)
      scrollContainer.current.style.transform = `translateX(${state.current.last}px)`;

    requestRef.current = requestAnimationFrame(smooth); //way requestAnimation
  };

  const handleResize = () => {
    state.current.bounds = { width: convertRem(255.25) };
  };

  const onHover = (id) => {
    setHovered(id);
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{
        opacity: 0,
        transition: {
          delay: 0,
          duration: 0.4,
        },
      }}
      transition={{ delay: 0.5, duration: 1.5 }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      id="titles"
    >
      <div ref={scrollContainer}>
        {titles.map((title) => (
          <Title
            onClick={() =>
              !state.current.dragging
                ? history.push(`/chapter/${title.id}`)
                : null
            }
            titlesRef={titlesRef.current}
            onHover={onHover}
            title={title}
            show={hovered === title.id}
            key={title.id}
            mouse={mouse}
          />
        ))}
      </div>
    </motion.div>
  );
};

const Title = ({ onClick, titlesRef, onHover, title, show, mouse }) => {
  const parsedId = parseInt(title.id) - 1;
  return (
    <div
      ref={(element) => (titlesRef[parsedId] = element)}
      onClick={onClick}
      onMouseEnter={() => onHover(title.id)}
      onMouseLeave={() => onHover(null)}
      className="title"
      style={{
        width: `${title.width + 5.5}rem`,
        left: `${title.x}rem`,
        top: `${title.yPercent}%`,
      }}
      key={title.id}
    >
      <motion.div className="id">{title.id}.</motion.div>
      <motion.div className="text">{title.text}</motion.div>

      <Image
        id={title.id}
        container={titlesRef[parsedId]}
        mouse={mouse}
        show={show}
        image={title.image}
        y={title.imageY}
      />
    </div>
  );
};

const Image = ({ id, container, mouse, show, image, y }) => {
  const [position, setPosition] = useState({ x: 50, y: 50 });

  useEffect(() => {
    if (show) {
      let { left, width } = container.getBoundingClientRect();
      let top = container.offsetTop;
      let height = container.offsetHeight;
      let _w = left + width / 2;
      let _h = (top + height + top) / 2;

      let x = 50 + (mouse.x - _w) * 0.06;
      let y = 50 + (mouse.y - _h) * 0.06;
      setPosition({ x, y });
    }
  }, [mouse]);

  return (
    <motion.div
      style={{ left: `${position.x}%`, top: `${position.y}%` }}
      animate={{ opacity: show ? 1 : 0 }}
      className="image"
    >
      <motion.img
        transition={{ duration: 0 }}
        initial={{ top: 0 }}
        animate={{ top: 0 }}
        exit={{ top: -150, transition: { duration: 0.6 } }}
        layoutId={id}
        style={{
          position: "relative",
          objectPosition: `0 ${y}rem`,
        }}
        src={image}
      />
    </motion.div>
  );
};

export default IndexNav;
